import { Link } from "react-router-dom";

export const Logo = ({ className = "", size = "md" }) => {
  const sizes = {
    sm: { primary: "text-[15px]", secondary: "text-[9px]" },
    md: { primary: "text-[19px]", secondary: "text-[10px]" },
    lg: { primary: "text-[28px]", secondary: "text-[12px]" },
  };
  const s = sizes[size] || sizes.md;

  return (
    <Link
      to="/"
      data-testid="brand-logo"
      className={`group inline-flex flex-col items-start leading-none ${className}`}
    >
      <span
        className={`font-serif ${s.primary} text-gold tracking-[0.02em]`}
        style={{ fontWeight: 500 }}
      >
        SABLE
      </span>
      <span
        className={`mt-1 ${s.secondary} tracking-[0.42em] text-gold/80`}
      >
        ADVISORY
      </span>
    </Link>
  );
};

export default Logo;
